// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
    font-family: Arial, sans-serif;
    margin: 10px;
}

.header {
    text-align: center;
}

.logo {
    height: 24px;
    margin-top: 7px;
}

.container {
    border: 1px solid #f1f3f5;
    border-radius: 20px;
    padding: 12px 16px 24px;
    background-color: #fff;
}

.car {
    border: 1px solid #eceef0;
    border-radius: 12px;
    padding: 26px 12px;
    background-color: #f7f8fa;
    margin: 5px;
}

.input-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.select-wrap {
    position: relative;
    min-width: 40%;
    max-width: 40%;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    border-radius: 16px;
    font-size: 16px;
    line-height: 1;
    background-color: #fff;
    box-shadow: 0 8px 14px #0000000d;
    display: flex;
    padding: 12px 15px;
    align-items: center;
}

.selected-logo {
    width: 36px;
    height: 36px;
    margin-right: 12px;
}

.vertical-middle {
    font-size: 16px;
}

.exchange-arrow img {

    position: relative;
    width: 46px;
    height: 46px;
    margin-top: -23px;
    z-index: 3;
}

.exchange-arrow {
    position: relative;
    height: 2px;
    text-align: center;
}
.input-amount-wrap {
    font-size: 22px;
    text-align: right;
}

.min-amount-tip {
    color: #999;
    font-size: 12px;
}

.confirm-wrap .van-button {
    width: 100%;
    padding: 10px;
    color: white;
    font-size: 16px;
    border-radius: 12px;
}

.info-cell {
    display: flex;
    justify-content: space-between;
    margin: 8px 0;
    color: #9ea0a5;
}
.ppp{
    text-align: right;width: 100%;display: block;color: #43464e;
}`, "",{"version":3,"sources":["webpack://./src/components/SwapPage.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,cAAc;AAClB;AACA;IACI,iBAAiB,CAAC,WAAW,CAAC,cAAc,CAAC,cAAc;AAC/D","sourcesContent":[".page-container {\r\n    font-family: Arial, sans-serif;\r\n    margin: 10px;\r\n}\r\n\r\n.header {\r\n    text-align: center;\r\n}\r\n\r\n.logo {\r\n    height: 24px;\r\n    margin-top: 7px;\r\n}\r\n\r\n.container {\r\n    border: 1px solid #f1f3f5;\r\n    border-radius: 20px;\r\n    padding: 12px 16px 24px;\r\n    background-color: #fff;\r\n}\r\n\r\n.car {\r\n    border: 1px solid #eceef0;\r\n    border-radius: 12px;\r\n    padding: 26px 12px;\r\n    background-color: #f7f8fa;\r\n    margin: 5px;\r\n}\r\n\r\n.input-section {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.select-wrap {\r\n    position: relative;\r\n    min-width: 40%;\r\n    max-width: 40%;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    border-radius: 16px;\r\n    font-size: 16px;\r\n    line-height: 1;\r\n    background-color: #fff;\r\n    box-shadow: 0 8px 14px #0000000d;\r\n    display: flex;\r\n    padding: 12px 15px;\r\n    align-items: center;\r\n}\r\n\r\n.selected-logo {\r\n    width: 36px;\r\n    height: 36px;\r\n    margin-right: 12px;\r\n}\r\n\r\n.vertical-middle {\r\n    font-size: 16px;\r\n}\r\n\r\n.exchange-arrow img {\r\n\r\n    position: relative;\r\n    width: 46px;\r\n    height: 46px;\r\n    margin-top: -23px;\r\n    z-index: 3;\r\n}\r\n\r\n.exchange-arrow {\r\n    position: relative;\r\n    height: 2px;\r\n    text-align: center;\r\n}\r\n.input-amount-wrap {\r\n    font-size: 22px;\r\n    text-align: right;\r\n}\r\n\r\n.min-amount-tip {\r\n    color: #999;\r\n    font-size: 12px;\r\n}\r\n\r\n.confirm-wrap .van-button {\r\n    width: 100%;\r\n    padding: 10px;\r\n    color: white;\r\n    font-size: 16px;\r\n    border-radius: 12px;\r\n}\r\n\r\n.info-cell {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 8px 0;\r\n    color: #9ea0a5;\r\n}\r\n.ppp{\r\n    text-align: right;width: 100%;display: block;color: #43464e;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
